import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';
import { batchResult } from '../../../util/DataObject';

export type BatchProps = {
    onClose: () => void;
    open: boolean;
    title: string;
    result: any;
} & DefaultComponentProps;

export const BatchDialog = ({ onClose, open, title, result }: BatchProps) => {
   
    const DemoPaper = styled(Paper)(({ theme }) => ({
        width: '33%',
        padding: theme.spacing(2),
        ...theme.typography.body2,
        textAlign: 'center',
        fontSize: 16,
        fontFamily: 'Muli,sans-serif'
    }));

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant="smallTitle">{title}</Typography>
            </DialogTitle>
            <DialogContent>
                {result && 
                    <FlexGrid container spacing={2} style={{marginBottom: 15, marginTop: 25}}>
                        {Object.keys(result).sort().map((item) => {
                            return <DemoPaper elevation={6} key={item}><Box>{batchResult[item]}</Box> <Box>{result[item]}</Box></DemoPaper>
                        })}
                    </FlexGrid>
                }
            </DialogContent> 
            <DialogActions>
                <FlexGrid fullHeight alignItems='flex-end' style={{ marginTop: 20}}>
                    <Button onClick={onClose} size='normal'>
                        Aceptar
                    </Button>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
